<template>
  <div class="content-i">
    <div class="context-box">
      <div class="element-box">
        <div class="col-md-6 offset-md-3">
          <form @submit.prevent="ativar">
            <h5 class="form-head">
                Validação do Celular
            </h5>
            <div class="form-desc">
                Caro credenciado. Você receberá um SMS, para o número de celular informado no cadastro, contendo o código de ativação.
            </div>
            <div class="form-row">
              <div class="form-group">
                <label for="codigo">Informe o código enviado por SMS</label>
                <input required v-model="payload.codigo" type="text" class="form-control" name="codigo" id="codigo">
              </div>
            </div>
            <div class="form-buttons-w">
                <button type="submit" class="btn btn-primary">Validar</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      payload: {
        codigo: null
      }
    }
  },
  methods: {
    ativar () {
      this.$store.dispatch('ativarPrecadastro', this.payload)
        .then(() => this.$router.push({name: 'Precadastro-sucesso'}))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/precadastro/Validacao.vue